export default "__VITE_ASSET__DaX08WDa__"